export default __webpack_public_path__ + "d4f95e28d6f6a4ea31546e25c7fe5dab.png";